// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { resolveOrganizationScope } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/reporting(.:format)`
 * - Path helper: `group_settings_reporting_path`
 * - URL helper: `group_settings_reporting_url`
 * - controller#action: `groups/settings/reporting#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsReportingPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsReportingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsReportingPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsReportingPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsReportingPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/domain_verification/:id/verify(.:format)`
 * - Path helper: `verify_group_settings_domain_verification_path`
 * - URL helper: `verify_group_settings_domain_verification_url`
 * - controller#action: `groups/settings/domain_verification#verify`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const verifyGroupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _verifyOrganizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _verifyGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _verifyOrganizationGroupSettingsDomainVerificationPath(organizationPath, ...routeArgs);
  }

  return _verifyGroupSettingsDomainVerificationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/domain_verification/:id/retry_auto_ssl(.:format)`
 * - Path helper: `retry_auto_ssl_group_settings_domain_verification_path`
 * - URL helper: `retry_auto_ssl_group_settings_domain_verification_url`
 * - controller#action: `groups/settings/domain_verification#retry_auto_ssl`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const retryAutoSslGroupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _retryAutoSslOrganizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_auto_ssl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _retryAutoSslGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_auto_ssl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _retryAutoSslOrganizationGroupSettingsDomainVerificationPath(organizationPath, ...routeArgs);
  }

  return _retryAutoSslGroupSettingsDomainVerificationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/domain_verification/:id/clean_certificate(.:format)`
 * - Path helper: `clean_certificate_group_settings_domain_verification_path`
 * - URL helper: `clean_certificate_group_settings_domain_verification_url`
 * - controller#action: `groups/settings/domain_verification#clean_certificate`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const cleanCertificateGroupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _cleanCertificateOrganizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clean_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _cleanCertificateGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clean_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _cleanCertificateOrganizationGroupSettingsDomainVerificationPath(organizationPath, ...routeArgs);
  }

  return _cleanCertificateGroupSettingsDomainVerificationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/domain_verification(.:format)`
 * - Path helper: `group_settings_domain_verification_index_path`
 * - URL helper: `group_settings_domain_verification_index_url`
 * - controller#action: `groups/settings/domain_verification#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsDomainVerificationIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsDomainVerificationIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsDomainVerificationIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsDomainVerificationIndexPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsDomainVerificationIndexPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/domain_verification/new(.:format)`
 * - Path helper: `new_group_settings_domain_verification_path`
 * - URL helper: `new_group_settings_domain_verification_url`
 * - controller#action: `groups/settings/domain_verification#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupSettingsDomainVerificationPath(organizationPath, ...routeArgs);
  }

  return _newGroupSettingsDomainVerificationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/domain_verification/:id(.:format)`
 * - Path helper: `group_settings_domain_verification_path`
 * - URL helper: `group_settings_domain_verification_url`
 * - controller#action: `groups/settings/domain_verification#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsDomainVerificationPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsDomainVerificationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/roles_and_permissions(.:format)`
 * - Path helper: `group_settings_roles_and_permissions_path`
 * - URL helper: `group_settings_roles_and_permissions_url`
 * - controller#action: `groups/settings/roles_and_permissions#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsRolesAndPermissionsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsRolesAndPermissionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsRolesAndPermissionsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsRolesAndPermissionsPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsRolesAndPermissionsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/roles_and_permissions/new(.:format)`
 * - Path helper: `new_group_settings_roles_and_permission_path`
 * - URL helper: `new_group_settings_roles_and_permission_url`
 * - controller#action: `groups/settings/roles_and_permissions#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupSettingsRolesAndPermissionPath(organizationPath, ...routeArgs);
  }

  return _newGroupSettingsRolesAndPermissionPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/roles_and_permissions/:id/edit(.:format)`
 * - Path helper: `edit_group_settings_roles_and_permission_path`
 * - URL helper: `edit_group_settings_roles_and_permission_url`
 * - controller#action: `groups/settings/roles_and_permissions#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupSettingsRolesAndPermissionPath(organizationPath, ...routeArgs);
  }

  return _editGroupSettingsRolesAndPermissionPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/roles_and_permissions/:id(.:format)`
 * - Path helper: `group_settings_roles_and_permission_path`
 * - URL helper: `group_settings_roles_and_permission_url`
 * - controller#action: `groups/settings/roles_and_permissions#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsRolesAndPermissionPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsRolesAndPermissionPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsRolesAndPermissionPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/analytics(.:format)`
 * - Path helper: `group_settings_analytics_path`
 * - URL helper: `group_settings_analytics_url`
 * - controller#action: `groups/settings/analytics#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/gitlab_duo(.:format)`
 * - Path helper: `group_settings_gitlab_duo_path`
 * - URL helper: `group_settings_gitlab_duo_url`
 * - controller#action: `groups/settings/gitlab_duo#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsGitlabDuoPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsGitlabDuoPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/orbit(.:format)`
 * - Path helper: `group_settings_orbit_path`
 * - URL helper: `group_settings_orbit_url`
 * - controller#action: `groups/settings/orbit#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsOrbitPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsOrbitPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"orbit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsOrbitPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"orbit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsOrbitPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsOrbitPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/secure(.:format)`
 * - Path helper: `group_settings_secure_path`
 * - URL helper: `group_settings_secure_url`
 * - controller#action: `groups/settings/secure#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsSecurePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsSecurePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"secure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsSecurePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"secure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsSecurePath(organizationPath, ...routeArgs);
  }

  return _groupSettingsSecurePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/gitlab_duo/seat_utilization(.:format)`
 * - Path helper: `group_settings_gitlab_duo_seat_utilization_index_path`
 * - URL helper: `group_settings_gitlab_duo_seat_utilization_index_url`
 * - controller#action: `groups/settings/gitlab_duo/seat_utilization#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoSeatUtilizationIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoSeatUtilizationIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"seat_utilization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoSeatUtilizationIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"seat_utilization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsGitlabDuoSeatUtilizationIndexPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsGitlabDuoSeatUtilizationIndexPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/gitlab_duo/configuration(.:format)`
 * - Path helper: `group_settings_gitlab_duo_configuration_index_path`
 * - URL helper: `group_settings_gitlab_duo_configuration_index_url`
 * - controller#action: `groups/settings/gitlab_duo/configuration#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoConfigurationIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoConfigurationIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoConfigurationIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsGitlabDuoConfigurationIndexPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsGitlabDuoConfigurationIndexPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/gitlab_duo/model_selection(.:format)`
 * - Path helper: `group_settings_gitlab_duo_model_selection_index_path`
 * - URL helper: `group_settings_gitlab_duo_model_selection_index_url`
 * - controller#action: `groups/settings/gitlab_duo/model_selection#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoModelSelectionIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoModelSelectionIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"model_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoModelSelectionIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"model_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsGitlabDuoModelSelectionIndexPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsGitlabDuoModelSelectionIndexPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/gitlab_credits_dashboard(.:format)`
 * - Path helper: `group_settings_gitlab_credits_dashboard_index_path`
 * - URL helper: `group_settings_gitlab_credits_dashboard_index_url`
 * - controller#action: `groups/settings/gitlab_credits_dashboard#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsGitlabCreditsDashboardIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabCreditsDashboardIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabCreditsDashboardIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsGitlabCreditsDashboardIndexPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsGitlabCreditsDashboardIndexPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/gitlab_credits_dashboard/users/:username`
 * - Path helper: `group_settings_gitlab_credits_dashboard_user_path`
 * - URL helper: `group_settings_gitlab_credits_dashboard_user_url`
 * - controller#action: `groups/settings/gitlab_credits_dashboard/users#show`
 *
 * @param {any} groupId
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsGitlabCreditsDashboardUserPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabCreditsDashboardUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"username":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[3,"username"]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabCreditsDashboardUserPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"username":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[3,"username"]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsGitlabCreditsDashboardUserPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsGitlabCreditsDashboardUserPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/gitlab_credits_dashboard/credit_caps(.:format)`
 * - Path helper: `group_settings_gitlab_credits_dashboard_credit_caps_path`
 * - URL helper: `group_settings_gitlab_credits_dashboard_credit_caps_url`
 * - controller#action: `groups/settings/gitlab_credits_dashboard/credit_caps#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsGitlabCreditsDashboardCreditCapsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabCreditsDashboardCreditCapsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[2,[7,"/"],[2,[6,"credit_caps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabCreditsDashboardCreditCapsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[2,[7,"/"],[2,[6,"credit_caps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsGitlabCreditsDashboardCreditCapsPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsGitlabCreditsDashboardCreditCapsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/gitlab_duo_usage(.:format)`
 * - Path helper: `group_settings_gitlab_duo_usage_path`
 * - URL helper: `group_settings_gitlab_duo_usage_url`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoUsagePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoUsagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoUsagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsGitlabDuoUsagePath(organizationPath, ...routeArgs);
  }

  return _groupSettingsGitlabDuoUsagePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/workspaces(.:format)`
 * - Path helper: `group_settings_workspaces_path`
 * - URL helper: `group_settings_workspaces_url`
 * - controller#action: `groups/settings/remote_development/workspaces#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsWorkspacesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsWorkspacesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"workspaces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsWorkspacesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"workspaces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsWorkspacesPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsWorkspacesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/work_items(/*vueroute)`
 * - Path helper: `work_items_group_settings_work_items_path`
 * - URL helper: `work_items_group_settings_work_items_url`
 * - controller#action: `groups/settings/work_items#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const workItemsGroupSettingsWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _workItemsOrganizationGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]]]);
  const _workItemsGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _workItemsOrganizationGroupSettingsWorkItemsPath(organizationPath, ...routeArgs);
  }

  return _workItemsGroupSettingsWorkItemsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/work_items/new(.:format)`
 * - Path helper: `new_group_settings_work_items_path`
 * - URL helper: `new_group_settings_work_items_url`
 * - controller#action: `groups/settings/work_items#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupSettingsWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupSettingsWorkItemsPath(organizationPath, ...routeArgs);
  }

  return _newGroupSettingsWorkItemsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/work_items/edit(.:format)`
 * - Path helper: `edit_group_settings_work_items_path`
 * - URL helper: `edit_group_settings_work_items_url`
 * - controller#action: `groups/settings/work_items#edit`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupSettingsWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupSettingsWorkItemsPath(organizationPath, ...routeArgs);
  }

  return _editGroupSettingsWorkItemsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/work_items(.:format)`
 * - Path helper: `group_settings_work_items_path`
 * - URL helper: `group_settings_work_items_url`
 * - controller#action: `groups/settings/work_items#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsWorkItemsPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsWorkItemsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/issues(.:format)`
 * - Path helper: `group_settings_issues_path`
 * - URL helper: `group_settings_issues_url`
 * - controller#action: `groups/settings/work_items#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsIssuesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsIssuesPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsIssuesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/packages_and_registries/virtual_registry_cleanup_policy(.:format)`
 * - Path helper: `group_settings_packages_and_registries_virtual_registry_cleanup_policy_index_path`
 * - URL helper: `group_settings_packages_and_registries_virtual_registry_cleanup_policy_index_url`
 * - controller#action: `groups/settings/packages_and_registries/virtual_registry_cleanup_policy#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[2,[7,"/"],[2,[6,"virtual_registry_cleanup_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[2,[7,"/"],[2,[6,"virtual_registry_cleanup_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath(organizationPath, ...routeArgs);
  }

  return _groupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/:id/override(.:format)`
 * - Path helper: `override_group_group_member_path`
 * - URL helper: `override_group_group_member_url`
 * - controller#action: `groups/group_members#override`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const overrideGroupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _overrideOrganizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _overrideGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _overrideOrganizationGroupGroupMemberPath(organizationPath, ...routeArgs);
  }

  return _overrideGroupGroupMemberPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/:id/unban(.:format)`
 * - Path helper: `unban_group_group_member_path`
 * - URL helper: `unban_group_group_member_url`
 * - controller#action: `groups/group_members#unban`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const unbanGroupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _unbanOrganizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _unbanGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _unbanOrganizationGroupGroupMemberPath(organizationPath, ...routeArgs);
  }

  return _unbanGroupGroupMemberPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/:id/ban(.:format)`
 * - Path helper: `ban_group_group_member_path`
 * - URL helper: `ban_group_group_member_url`
 * - controller#action: `groups/group_members#ban`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const banGroupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _banOrganizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _banGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _banOrganizationGroupGroupMemberPath(organizationPath, ...routeArgs);
  }

  return _banGroupGroupMemberPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/export_csv(.:format)`
 * - Path helper: `export_csv_group_group_members_path`
 * - URL helper: `export_csv_group_group_members_url`
 * - controller#action: `groups/group_members#export_csv`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exportCsvGroupGroupMembersPath = /*#__PURE__*/ (...args) => {
  const _exportCsvOrganizationGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _exportCsvGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _exportCsvOrganizationGroupGroupMembersPath(organizationPath, ...routeArgs);
  }

  return _exportCsvGroupGroupMembersPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/two_factor_auth(.:format)`
 * - Path helper: `group_two_factor_auth_path`
 * - URL helper: `group_two_factor_auth_url`
 * - controller#action: `groups/two_factor_auths#destroy`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupTwoFactorAuthPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"two_factor_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"two_factor_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupTwoFactorAuthPath(organizationPath, ...routeArgs);
  }

  return _groupTwoFactorAuthPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics(.:format)`
 * - Path helper: `group_analytics_path`
 * - URL helper: `group_analytics_url`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/contribution_analytics(.:format)`
 * - Path helper: `group_contribution_analytics_path`
 * - URL helper: `group_contribution_analytics_url`
 * - controller#action: `groups/contribution_analytics#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupContributionAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupContributionAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"contribution_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupContributionAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"contribution_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupContributionAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupContributionAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/ci_cd(.:format)`
 * - Path helper: `group_analytics_ci_cd_analytics_path`
 * - URL helper: `group_analytics_ci_cd_analytics_url`
 * - controller#action: `groups/analytics/ci_cd_analytics#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCiCdAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCiCdAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCiCdAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCiCdAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCiCdAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/dashboards(/*vueroute)`
 * - Path helper: `group_analytics_dashboards_path`
 * - URL helper: `group_analytics_dashboards_url`
 * - controller#action: `groups/analytics/dashboards#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsDashboardsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsDashboardsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsDashboardsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/devops_adoption(.:format)`
 * - Path helper: `group_analytics_devops_adoption_path`
 * - URL helper: `group_analytics_devops_adoption_url`
 * - controller#action: `groups/analytics/devops_adoption#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsDevopsAdoptionPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsDevopsAdoptionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"devops_adoption"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsDevopsAdoptionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"devops_adoption"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsDevopsAdoptionPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsDevopsAdoptionPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/productivity_analytics(.:format)`
 * - Path helper: `group_analytics_productivity_analytics_path`
 * - URL helper: `group_analytics_productivity_analytics_url`
 * - controller#action: `groups/analytics/productivity_analytics#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsProductivityAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsProductivityAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"productivity_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsProductivityAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"productivity_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsProductivityAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsProductivityAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/coverage_reports(.:format)`
 * - Path helper: `group_analytics_coverage_reports_path`
 * - URL helper: `group_analytics_coverage_reports_url`
 * - controller#action: `groups/analytics/coverage_reports#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCoverageReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCoverageReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"coverage_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCoverageReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"coverage_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCoverageReportsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCoverageReportsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/merge_request_analytics(.:format)`
 * - Path helper: `group_analytics_merge_request_analytics_path`
 * - URL helper: `group_analytics_merge_request_analytics_url`
 * - controller#action: `groups/analytics/merge_request_analytics#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"merge_request_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"merge_request_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsMergeRequestAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsMergeRequestAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/repository_analytics(.:format)`
 * - Path helper: `group_analytics_repository_analytics_path`
 * - URL helper: `group_analytics_repository_analytics_url`
 * - controller#action: `groups/analytics/repository_analytics#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsRepositoryAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsRepositoryAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"repository_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsRepositoryAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"repository_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsRepositoryAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsRepositoryAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics(.:format)`
 * - Path helper: `group_analytics_cycle_analytics_path`
 * - URL helper: `group_analytics_cycle_analytics_url`
 * - controller#action: `groups/analytics/cycle_analytics#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCycleAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCycleAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/average_duration_chart(.:format)`
 * - Path helper: `average_duration_chart_group_analytics_cycle_analytics_value_stream_stage_path`
 * - URL helper: `average_duration_chart_group_analytics_cycle_analytics_value_stream_stage_url`
 * - controller#action: `groups/analytics/cycle_analytics/stages#average_duration_chart`
 *
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const averageDurationChartGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _averageDurationChartOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average_duration_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _averageDurationChartGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average_duration_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _averageDurationChartOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(organizationPath, ...routeArgs);
  }

  return _averageDurationChartGroupAnalyticsCycleAnalyticsValueStreamStagePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/median(.:format)`
 * - Path helper: `median_group_analytics_cycle_analytics_value_stream_stage_path`
 * - URL helper: `median_group_analytics_cycle_analytics_value_stream_stage_url`
 * - controller#action: `groups/analytics/cycle_analytics/stages#median`
 *
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const medianGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _medianOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"median"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _medianGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"median"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _medianOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(organizationPath, ...routeArgs);
  }

  return _medianGroupAnalyticsCycleAnalyticsValueStreamStagePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/average(.:format)`
 * - Path helper: `average_group_analytics_cycle_analytics_value_stream_stage_path`
 * - URL helper: `average_group_analytics_cycle_analytics_value_stream_stage_url`
 * - controller#action: `groups/analytics/cycle_analytics/stages#average`
 *
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const averageGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _averageOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _averageGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _averageOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(organizationPath, ...routeArgs);
  }

  return _averageGroupAnalyticsCycleAnalyticsValueStreamStagePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/records(.:format)`
 * - Path helper: `records_group_analytics_cycle_analytics_value_stream_stage_path`
 * - URL helper: `records_group_analytics_cycle_analytics_value_stream_stage_url`
 * - controller#action: `groups/analytics/cycle_analytics/stages#records`
 *
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const recordsGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _recordsOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _recordsGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _recordsOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(organizationPath, ...routeArgs);
  }

  return _recordsGroupAnalyticsCycleAnalyticsValueStreamStagePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/count(.:format)`
 * - Path helper: `count_group_analytics_cycle_analytics_value_stream_stage_path`
 * - URL helper: `count_group_analytics_cycle_analytics_value_stream_stage_url`
 * - controller#action: `groups/analytics/cycle_analytics/stages#count`
 *
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const countGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _countOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _countGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _countOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(organizationPath, ...routeArgs);
  }

  return _countGroupAnalyticsCycleAnalyticsValueStreamStagePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages(.:format)`
 * - Path helper: `group_analytics_cycle_analytics_value_stream_stages_path`
 * - URL helper: `group_analytics_cycle_analytics_value_stream_stages_url`
 * - controller#action: `groups/analytics/cycle_analytics/stages#index`
 *
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCycleAnalyticsValueStreamStagesPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCycleAnalyticsValueStreamStagesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams(.:format)`
 * - Path helper: `group_analytics_cycle_analytics_value_streams_path`
 * - URL helper: `group_analytics_cycle_analytics_value_streams_url`
 * - controller#action: `groups/analytics/cycle_analytics/value_streams#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCycleAnalyticsValueStreamsPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCycleAnalyticsValueStreamsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/new(.:format)`
 * - Path helper: `new_group_analytics_cycle_analytics_value_stream_path`
 * - URL helper: `new_group_analytics_cycle_analytics_value_stream_url`
 * - controller#action: `groups/analytics/cycle_analytics/value_streams#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _newGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupAnalyticsCycleAnalyticsValueStreamPath(organizationPath, ...routeArgs);
  }

  return _newGroupAnalyticsCycleAnalyticsValueStreamPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/:id/edit(.:format)`
 * - Path helper: `edit_group_analytics_cycle_analytics_value_stream_path`
 * - URL helper: `edit_group_analytics_cycle_analytics_value_stream_url`
 * - controller#action: `groups/analytics/cycle_analytics/value_streams#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupAnalyticsCycleAnalyticsValueStreamPath(organizationPath, ...routeArgs);
  }

  return _editGroupAnalyticsCycleAnalyticsValueStreamPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/value_streams/:id(.:format)`
 * - Path helper: `group_analytics_cycle_analytics_value_stream_path`
 * - URL helper: `group_analytics_cycle_analytics_value_stream_url`
 * - controller#action: `groups/analytics/cycle_analytics/value_streams#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCycleAnalyticsValueStreamPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCycleAnalyticsValueStreamPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/summary(.:format)`
 * - Path helper: `group_analytics_cycle_analytics_summary_path`
 * - URL helper: `group_analytics_cycle_analytics_summary_url`
 * - controller#action: `groups/analytics/cycle_analytics/summary#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCycleAnalyticsSummaryPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCycleAnalyticsSummaryPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/time_summary(.:format)`
 * - Path helper: `group_analytics_cycle_analytics_time_summary_path`
 * - URL helper: `group_analytics_cycle_analytics_time_summary_url`
 * - controller#action: `groups/analytics/cycle_analytics/summary#time_summary`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"time_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"time_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCycleAnalyticsTimeSummaryPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCycleAnalyticsTimeSummaryPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/lead_times(.:format)`
 * - Path helper: `group_analytics_cycle_analytics_lead_times_path`
 * - URL helper: `group_analytics_cycle_analytics_lead_times_url`
 * - controller#action: `groups/analytics/cycle_analytics/summary#lead_times`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsLeadTimesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsLeadTimesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"lead_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsLeadTimesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"lead_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCycleAnalyticsLeadTimesPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCycleAnalyticsLeadTimesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/value_stream_analytics/cycle_times(.:format)`
 * - Path helper: `group_analytics_cycle_analytics_cycle_times_path`
 * - URL helper: `group_analytics_cycle_analytics_cycle_times_url`
 * - controller#action: `groups/analytics/cycle_analytics/summary#cycle_times`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsCycleTimesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsCycleTimesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"cycle_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsCycleTimesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"cycle_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsCycleAnalyticsCycleTimesPath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsCycleAnalyticsCycleTimesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/type_of_work/tasks_by_type/top_labels(.:format)`
 * - Path helper: `top_labels_group_analytics_tasks_by_type_path`
 * - URL helper: `top_labels_group_analytics_tasks_by_type_url`
 * - controller#action: `groups/analytics/tasks_by_type#top_labels`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const topLabelsGroupAnalyticsTasksByTypePath = /*#__PURE__*/ (...args) => {
  const _topLabelsOrganizationGroupAnalyticsTasksByTypePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"type_of_work"],[2,[7,"/"],[2,[6,"tasks_by_type"],[2,[7,"/"],[2,[6,"top_labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _topLabelsGroupAnalyticsTasksByTypePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"type_of_work"],[2,[7,"/"],[2,[6,"tasks_by_type"],[2,[7,"/"],[2,[6,"top_labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _topLabelsOrganizationGroupAnalyticsTasksByTypePath(organizationPath, ...routeArgs);
  }

  return _topLabelsGroupAnalyticsTasksByTypePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/analytics/type_of_work/tasks_by_type(.:format)`
 * - Path helper: `group_analytics_tasks_by_type_path`
 * - URL helper: `group_analytics_tasks_by_type_url`
 * - controller#action: `groups/analytics/tasks_by_type#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAnalyticsTasksByTypePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsTasksByTypePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"type_of_work"],[2,[7,"/"],[2,[6,"tasks_by_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsTasksByTypePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"type_of_work"],[2,[7,"/"],[2,[6,"tasks_by_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAnalyticsTasksByTypePath(organizationPath, ...routeArgs);
  }

  return _groupAnalyticsTasksByTypePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/ldap/sync(.:format)`
 * - Path helper: `sync_group_ldap_path`
 * - URL helper: `sync_group_ldap_url`
 * - controller#action: `groups/ldaps#sync`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const syncGroupLdapPath = /*#__PURE__*/ (...args) => {
  const _syncOrganizationGroupLdapPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _syncGroupLdapPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _syncOrganizationGroupLdapPath(organizationPath, ...routeArgs);
  }

  return _syncGroupLdapPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/issues_analytics(.:format)`
 * - Path helper: `group_issues_analytics_path`
 * - URL helper: `group_issues_analytics_url`
 * - controller#action: `groups/issues_analytics#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupIssuesAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIssuesAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupIssuesAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupIssuesAnalyticsPath(organizationPath, ...routeArgs);
  }

  return _groupIssuesAnalyticsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/insights/query(.:format)`
 * - Path helper: `query_group_insights_path`
 * - URL helper: `query_group_insights_url`
 * - controller#action: `groups/insights#query`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const queryGroupInsightsPath = /*#__PURE__*/ (...args) => {
  const _queryOrganizationGroupInsightsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _queryGroupInsightsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _queryOrganizationGroupInsightsPath(organizationPath, ...routeArgs);
  }

  return _queryGroupInsightsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/insights(.:format)`
 * - Path helper: `group_insights_path`
 * - URL helper: `group_insights_url`
 * - controller#action: `groups/insights#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupInsightsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupInsightsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupInsightsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupInsightsPath(organizationPath, ...routeArgs);
  }

  return _groupInsightsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/notification_setting(.:format)`
 * - Path helper: `group_notification_setting_path`
 * - URL helper: `group_notification_setting_url`
 * - controller#action: `groups/notification_settings#update`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupNotificationSettingPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupNotificationSettingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"notification_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupNotificationSettingPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"notification_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupNotificationSettingPath(organizationPath, ...routeArgs);
  }

  return _groupNotificationSettingPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/ldap_group_links(.:format)`
 * - Path helper: `group_ldap_group_links_path`
 * - URL helper: `group_ldap_group_links_url`
 * - controller#action: `groups/ldap_group_links#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupLdapGroupLinksPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupLdapGroupLinksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap_group_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupLdapGroupLinksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap_group_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupLdapGroupLinksPath(organizationPath, ...routeArgs);
  }

  return _groupLdapGroupLinksPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/ldap_group_links/:id(.:format)`
 * - Path helper: `group_ldap_group_link_path`
 * - URL helper: `group_ldap_group_link_url`
 * - controller#action: `groups/ldap_group_links#destroy`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupLdapGroupLinkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupLdapGroupLinkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap_group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupLdapGroupLinkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap_group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupLdapGroupLinkPath(organizationPath, ...routeArgs);
  }

  return _groupLdapGroupLinkPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/saml_group_links(.:format)`
 * - Path helper: `group_saml_group_links_path`
 * - URL helper: `group_saml_group_links_url`
 * - controller#action: `groups/saml_group_links#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSamlGroupLinksPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSamlGroupLinksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml_group_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupSamlGroupLinksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml_group_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSamlGroupLinksPath(organizationPath, ...routeArgs);
  }

  return _groupSamlGroupLinksPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/saml_group_links/:id(.:format)`
 * - Path helper: `group_saml_group_link_path`
 * - URL helper: `group_saml_group_link_url`
 * - controller#action: `groups/saml_group_links#destroy`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSamlGroupLinkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSamlGroupLinkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml_group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSamlGroupLinkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml_group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSamlGroupLinkPath(organizationPath, ...routeArgs);
  }

  return _groupSamlGroupLinkPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/audit_events(.:format)`
 * - Path helper: `group_audit_events_path`
 * - URL helper: `group_audit_events_url`
 * - controller#action: `groups/audit_events#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAuditEventsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAuditEventsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupAuditEventsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAuditEventsPath(organizationPath, ...routeArgs);
  }

  return _groupAuditEventsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/usage_quotas(.:format)`
 * - Path helper: `group_usage_quotas_path`
 * - URL helper: `group_usage_quotas_url`
 * - controller#action: `groups/usage_quotas#root`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupUsageQuotasPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupUsageQuotasPath(organizationPath, ...routeArgs);
  }

  return _groupUsageQuotasPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/usage_quotas/pending_members(.:format)`
 * - Path helper: `pending_members_group_usage_quotas_path`
 * - URL helper: `pending_members_group_usage_quotas_url`
 * - controller#action: `groups/usage_quotas#pending_members`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const pendingMembersGroupUsageQuotasPath = /*#__PURE__*/ (...args) => {
  const _pendingMembersOrganizationGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[2,[7,"/"],[2,[6,"pending_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _pendingMembersGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[2,[7,"/"],[2,[6,"pending_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _pendingMembersOrganizationGroupUsageQuotasPath(organizationPath, ...routeArgs);
  }

  return _pendingMembersGroupUsageQuotasPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/usage_quotas/subscription_history(.:format)`
 * - Path helper: `subscription_history_group_usage_quotas_path`
 * - URL helper: `subscription_history_group_usage_quotas_url`
 * - controller#action: `groups/usage_quotas#subscription_history`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const subscriptionHistoryGroupUsageQuotasPath = /*#__PURE__*/ (...args) => {
  const _subscriptionHistoryOrganizationGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[2,[7,"/"],[2,[6,"subscription_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _subscriptionHistoryGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[2,[7,"/"],[2,[6,"subscription_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _subscriptionHistoryOrganizationGroupUsageQuotasPath(organizationPath, ...routeArgs);
  }

  return _subscriptionHistoryGroupUsageQuotasPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/hooks/:id/test(.:format)`
 * - Path helper: `test_group_hook_path`
 * - URL helper: `test_group_hook_url`
 * - controller#action: `groups/hooks#test`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const testGroupHookPath = /*#__PURE__*/ (...args) => {
  const _testOrganizationGroupHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _testGroupHookPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _testOrganizationGroupHookPath(organizationPath, ...routeArgs);
  }

  return _testGroupHookPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/hooks/:hook_id/hook_logs/:id/retry(.:format)`
 * - Path helper: `retry_group_hook_hook_log_path`
 * - URL helper: `retry_group_hook_hook_log_url`
 * - controller#action: `groups/hook_logs#retry`
 *
 * @param {any} groupId
 * @param {any} hookId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const retryGroupHookHookLogPath = /*#__PURE__*/ (...args) => {
  const _retryOrganizationGroupHookHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _retryGroupHookHookLogPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _retryOrganizationGroupHookHookLogPath(organizationPath, ...routeArgs);
  }

  return _retryGroupHookHookLogPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/hooks/:hook_id/hook_logs/:id(.:format)`
 * - Path helper: `group_hook_hook_log_path`
 * - URL helper: `group_hook_hook_log_url`
 * - controller#action: `groups/hook_logs#show`
 *
 * @param {any} groupId
 * @param {any} hookId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupHookHookLogPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHookHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupHookHookLogPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupHookHookLogPath(organizationPath, ...routeArgs);
  }

  return _groupHookHookLogPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/hooks(.:format)`
 * - Path helper: `group_hooks_path`
 * - URL helper: `group_hooks_url`
 * - controller#action: `groups/hooks#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupHooksPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHooksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupHooksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupHooksPath(organizationPath, ...routeArgs);
  }

  return _groupHooksPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/hooks/:id/edit(.:format)`
 * - Path helper: `edit_group_hook_path`
 * - URL helper: `edit_group_hook_url`
 * - controller#action: `groups/hooks#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupHookPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupHookPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupHookPath(organizationPath, ...routeArgs);
  }

  return _editGroupHookPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/hooks/:id(.:format)`
 * - Path helper: `group_hook_path`
 * - URL helper: `group_hook_url`
 * - controller#action: `groups/hooks#update`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupHookPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupHookPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupHookPath(organizationPath, ...routeArgs);
  }

  return _groupHookPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/epics(.:format)`
 * - Path helper: `epics_group_autocomplete_sources_path`
 * - URL helper: `epics_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#epics`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const epicsGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _epicsOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _epicsGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _epicsOrganizationGroupAutocompleteSourcesPath(organizationPath, ...routeArgs);
  }

  return _epicsGroupAutocompleteSourcesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/iterations(.:format)`
 * - Path helper: `iterations_group_autocomplete_sources_path`
 * - URL helper: `iterations_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#iterations`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const iterationsGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _iterationsOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _iterationsGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _iterationsOrganizationGroupAutocompleteSourcesPath(organizationPath, ...routeArgs);
  }

  return _iterationsGroupAutocompleteSourcesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/vulnerabilities(.:format)`
 * - Path helper: `vulnerabilities_group_autocomplete_sources_path`
 * - URL helper: `vulnerabilities_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#vulnerabilities`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const vulnerabilitiesGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _vulnerabilitiesOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _vulnerabilitiesGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _vulnerabilitiesOrganizationGroupAutocompleteSourcesPath(organizationPath, ...routeArgs);
  }

  return _vulnerabilitiesGroupAutocompleteSourcesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/wikis(.:format)`
 * - Path helper: `wikis_group_autocomplete_sources_path`
 * - URL helper: `wikis_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#wikis`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const wikisGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _wikisOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"wikis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _wikisGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"wikis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _wikisOrganizationGroupAutocompleteSourcesPath(organizationPath, ...routeArgs);
  }

  return _wikisGroupAutocompleteSourcesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/billings/refresh_seats(.:format)`
 * - Path helper: `refresh_seats_group_billings_path`
 * - URL helper: `refresh_seats_group_billings_url`
 * - controller#action: `groups/billings#refresh_seats`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const refreshSeatsGroupBillingsPath = /*#__PURE__*/ (...args) => {
  const _refreshSeatsOrganizationGroupBillingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[2,[7,"/"],[2,[6,"refresh_seats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _refreshSeatsGroupBillingsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[2,[7,"/"],[2,[6,"refresh_seats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _refreshSeatsOrganizationGroupBillingsPath(organizationPath, ...routeArgs);
  }

  return _refreshSeatsGroupBillingsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/billings(.:format)`
 * - Path helper: `group_billings_path`
 * - URL helper: `group_billings_url`
 * - controller#action: `groups/billings#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupBillingsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupBillingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupBillingsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupBillingsPath(organizationPath, ...routeArgs);
  }

  return _groupBillingsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/seat_usage(.:format)`
 * - Path helper: `group_seat_usage_path`
 * - URL helper: `group_seat_usage_url`
 * - controller#action: `groups/seat_usage#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSeatUsagePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSeatUsagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"seat_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupSeatUsagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"seat_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSeatUsagePath(organizationPath, ...routeArgs);
  }

  return _groupSeatUsagePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/minimal_access_provisioning_alert_dismissal(.:format)`
 * - Path helper: `group_minimal_access_provisioning_alert_dismissal_path`
 * - URL helper: `group_minimal_access_provisioning_alert_dismissal_url`
 * - controller#action: `groups/minimal_access_provisioning_alert_dismissals#create`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupMinimalAccessProvisioningAlertDismissalPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupMinimalAccessProvisioningAlertDismissalPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"minimal_access_provisioning_alert_dismissal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupMinimalAccessProvisioningAlertDismissalPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"minimal_access_provisioning_alert_dismissal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupMinimalAccessProvisioningAlertDismissalPath(organizationPath, ...routeArgs);
  }

  return _groupMinimalAccessProvisioningAlertDismissalPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/comment_templates(.:format)`
 * - Path helper: `group_comment_templates_path`
 * - URL helper: `group_comment_templates_url`
 * - controller#action: `groups/comment_templates#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupCommentTemplatesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupCommentTemplatesPath(organizationPath, ...routeArgs);
  }

  return _groupCommentTemplatesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/comment_templates/:id(.:format)`
 * - Path helper: `group_comment_template_path`
 * - URL helper: `group_comment_template_url`
 * - controller#action: `groups/comment_templates#index`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupCommentTemplatePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCommentTemplatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupCommentTemplatePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupCommentTemplatePath(organizationPath, ...routeArgs);
  }

  return _groupCommentTemplatePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:id/descriptions/:version_id/diff(.:format)`
 * - Path helper: `description_diff_group_epic_path`
 * - URL helper: `description_diff_group_epic_url`
 * - controller#action: `groups/epics#description_diff`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {any} versionId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const descriptionDiffGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _descriptionDiffOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[2,[7,"/"],[2,[6,"diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _descriptionDiffGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[2,[7,"/"],[2,[6,"diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _descriptionDiffOrganizationGroupEpicPath(organizationPath, ...routeArgs);
  }

  return _descriptionDiffGroupEpicPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:id/descriptions/:version_id(.:format)`
 * - Path helper: `delete_description_version_group_epic_path`
 * - URL helper: `delete_description_version_group_epic_url`
 * - controller#action: `groups/epics#delete_description_version`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {any} versionId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const deleteDescriptionVersionGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _deleteDescriptionVersionOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _deleteDescriptionVersionGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _deleteDescriptionVersionOrganizationGroupEpicPath(organizationPath, ...routeArgs);
  }

  return _deleteDescriptionVersionGroupEpicPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:id/discussions(.:format)`
 * - Path helper: `discussions_group_epic_path`
 * - URL helper: `discussions_group_epic_url`
 * - controller#action: `groups/epics#discussions`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const discussionsGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _discussionsOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _discussionsGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _discussionsOrganizationGroupEpicPath(organizationPath, ...routeArgs);
  }

  return _discussionsGroupEpicPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:id/realtime_changes(.:format)`
 * - Path helper: `realtime_changes_group_epic_path`
 * - URL helper: `realtime_changes_group_epic_url`
 * - controller#action: `groups/epics#realtime_changes`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const realtimeChangesGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _realtimeChangesOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"realtime_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _realtimeChangesGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"realtime_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _realtimeChangesOrganizationGroupEpicPath(organizationPath, ...routeArgs);
  }

  return _realtimeChangesGroupEpicPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:id/toggle_subscription(.:format)`
 * - Path helper: `toggle_subscription_group_epic_path`
 * - URL helper: `toggle_subscription_group_epic_url`
 * - controller#action: `groups/epics#toggle_subscription`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const toggleSubscriptionGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _toggleSubscriptionOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleSubscriptionGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _toggleSubscriptionOrganizationGroupEpicPath(organizationPath, ...routeArgs);
  }

  return _toggleSubscriptionGroupEpicPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:epic_id/notes(.:format)`
 * - Path helper: `group_epic_notes_path`
 * - URL helper: `group_epic_notes_url`
 * - controller#action: `groups/epics/notes#index`
 *
 * @param {any} groupId
 * @param {any} epicId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupEpicNotesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicNotesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"epic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupEpicNotesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"epic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupEpicNotesPath(organizationPath, ...routeArgs);
  }

  return _groupEpicNotesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:epic_id/notes/:id(.:format)`
 * - Path helper: `group_epic_note_path`
 * - URL helper: `group_epic_note_url`
 * - controller#action: `groups/epics/notes#update`
 *
 * @param {any} groupId
 * @param {any} epicId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupEpicNotePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"epic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupEpicNotePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"epic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupEpicNotePath(organizationPath, ...routeArgs);
  }

  return _groupEpicNotePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/bulk_update(.:format)`
 * - Path helper: `bulk_update_group_epics_path`
 * - URL helper: `bulk_update_group_epics_url`
 * - controller#action: `groups/epics#bulk_update`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const bulkUpdateGroupEpicsPath = /*#__PURE__*/ (...args) => {
  const _bulkUpdateOrganizationGroupEpicsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _bulkUpdateGroupEpicsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _bulkUpdateOrganizationGroupEpicsPath(organizationPath, ...routeArgs);
  }

  return _bulkUpdateGroupEpicsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics(.:format)`
 * - Path helper: `group_epics_path`
 * - URL helper: `group_epics_url`
 * - controller#action: `groups/epics#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupEpicsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupEpicsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupEpicsPath(organizationPath, ...routeArgs);
  }

  return _groupEpicsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/new(.:format)`
 * - Path helper: `new_group_epic_path`
 * - URL helper: `new_group_epic_url`
 * - controller#action: `groups/epics#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupEpicPath(organizationPath, ...routeArgs);
  }

  return _newGroupEpicPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:id/edit(.:format)`
 * - Path helper: `edit_group_epic_path`
 * - URL helper: `edit_group_epic_url`
 * - controller#action: `groups/epics#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupEpicPath(organizationPath, ...routeArgs);
  }

  return _editGroupEpicPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:id(.:format)`
 * - Path helper: `group_epic_path`
 * - URL helper: `group_epic_url`
 * - controller#action: `groups/epics#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupEpicPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupEpicPath(organizationPath, ...routeArgs);
  }

  return _groupEpicPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/iterations(.:format)`
 * - Path helper: `group_iterations_path`
 * - URL helper: `group_iterations_url`
 * - controller#action: `groups/iterations#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupIterationsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupIterationsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupIterationsPath(organizationPath, ...routeArgs);
  }

  return _groupIterationsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/iterations/new(.:format)`
 * - Path helper: `new_group_iteration_path`
 * - URL helper: `new_group_iteration_url`
 * - controller#action: `groups/iterations#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupIterationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupIterationPath(organizationPath, ...routeArgs);
  }

  return _newGroupIterationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/iterations/:id/edit(.:format)`
 * - Path helper: `edit_group_iteration_path`
 * - URL helper: `edit_group_iteration_url`
 * - controller#action: `groups/iterations#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupIterationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupIterationPath(organizationPath, ...routeArgs);
  }

  return _editGroupIterationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/iterations/:id(.:format)`
 * - Path helper: `group_iteration_path`
 * - URL helper: `group_iteration_url`
 * - controller#action: `groups/iterations#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupIterationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupIterationPath(organizationPath, ...routeArgs);
  }

  return _groupIterationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/cadences(/*vueroute)/:iteration_cadence_id/iterations(.:format)`
 * - Path helper: `group_iteration_cadence_iterations_path`
 * - URL helper: `group_iteration_cadence_iterations_url`
 * - controller#action: `groups/iteration_cadences#index`
 *
 * @param {any} groupId
 * @param {any} iterationCadenceId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupIterationCadenceIterationsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationCadenceIterationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _groupIterationCadenceIterationsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupIterationCadenceIterationsPath(organizationPath, ...routeArgs);
  }

  return _groupIterationCadenceIterationsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/cadences(/*vueroute)/:iteration_cadence_id/iterations/new(.:format)`
 * - Path helper: `new_group_iteration_cadence_iteration_path`
 * - URL helper: `new_group_iteration_cadence_iteration_url`
 * - controller#action: `groups/iteration_cadences#index`
 *
 * @param {any} groupId
 * @param {any} iterationCadenceId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupIterationCadenceIterationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]);
  const _newGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupIterationCadenceIterationPath(organizationPath, ...routeArgs);
  }

  return _newGroupIterationCadenceIterationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/cadences(/*vueroute)/:iteration_cadence_id/iterations/:id/edit(.:format)`
 * - Path helper: `edit_group_iteration_cadence_iteration_path`
 * - URL helper: `edit_group_iteration_cadence_iteration_url`
 * - controller#action: `groups/iteration_cadences#index`
 *
 * @param {any} groupId
 * @param {any} iterationCadenceId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupIterationCadenceIterationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupIterationCadenceIterationPath(organizationPath, ...routeArgs);
  }

  return _editGroupIterationCadenceIterationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/cadences(/*vueroute)/:iteration_cadence_id/iterations/:id(.:format)`
 * - Path helper: `group_iteration_cadence_iteration_path`
 * - URL helper: `group_iteration_cadence_iteration_url`
 * - controller#action: `groups/iteration_cadences#index`
 *
 * @param {any} groupId
 * @param {any} iterationCadenceId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupIterationCadenceIterationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]);
  const _groupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupIterationCadenceIterationPath(organizationPath, ...routeArgs);
  }

  return _groupIterationCadenceIterationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/cadences(/*vueroute)(.:format)`
 * - Path helper: `group_iteration_cadences_path`
 * - URL helper: `group_iteration_cadences_url`
 * - controller#action: `groups/iteration_cadences#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupIterationCadencesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationCadencesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _groupIterationCadencesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupIterationCadencesPath(organizationPath, ...routeArgs);
  }

  return _groupIterationCadencesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/cadences(/*vueroute)/new(.:format)`
 * - Path helper: `new_group_iteration_cadence_path`
 * - URL helper: `new_group_iteration_cadence_url`
 * - controller#action: `groups/iteration_cadences#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupIterationCadencePath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _newGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupIterationCadencePath(organizationPath, ...routeArgs);
  }

  return _newGroupIterationCadencePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/cadences(/*vueroute)/:id/edit(.:format)`
 * - Path helper: `edit_group_iteration_cadence_path`
 * - URL helper: `edit_group_iteration_cadence_url`
 * - controller#action: `groups/iteration_cadences#index`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupIterationCadencePath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _editGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupIterationCadencePath(organizationPath, ...routeArgs);
  }

  return _editGroupIterationCadencePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/cadences(/*vueroute)/:id(.:format)`
 * - Path helper: `group_iteration_cadence_path`
 * - URL helper: `group_iteration_cadence_url`
 * - controller#action: `groups/iteration_cadences#index`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupIterationCadencePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _groupIterationCadencePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupIterationCadencePath(organizationPath, ...routeArgs);
  }

  return _groupIterationCadencePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/issues/bulk_update(.:format)`
 * - Path helper: `bulk_update_group_issues_path`
 * - URL helper: `bulk_update_group_issues_url`
 * - controller#action: `groups/issues#bulk_update`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const bulkUpdateGroupIssuesPath = /*#__PURE__*/ (...args) => {
  const _bulkUpdateOrganizationGroupIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _bulkUpdateGroupIssuesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _bulkUpdateOrganizationGroupIssuesPath(organizationPath, ...routeArgs);
  }

  return _bulkUpdateGroupIssuesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/merge_requests/bulk_update(.:format)`
 * - Path helper: `bulk_update_group_merge_requests_path`
 * - URL helper: `bulk_update_group_merge_requests_url`
 * - controller#action: `groups/merge_requests#bulk_update`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const bulkUpdateGroupMergeRequestsPath = /*#__PURE__*/ (...args) => {
  const _bulkUpdateOrganizationGroupMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _bulkUpdateGroupMergeRequestsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _bulkUpdateOrganizationGroupMergeRequestsPath(organizationPath, ...routeArgs);
  }

  return _bulkUpdateGroupMergeRequestsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/todos(.:format)`
 * - Path helper: `group_todos_path`
 * - URL helper: `group_todos_url`
 * - controller#action: `groups/todos#create`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupTodosPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupTodosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupTodosPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupTodosPath(organizationPath, ...routeArgs);
  }

  return _groupTodosPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epic_boards(.:format)`
 * - Path helper: `group_epic_boards_path`
 * - URL helper: `group_epic_boards_url`
 * - controller#action: `groups/epic_boards#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupEpicBoardsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicBoardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epic_boards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupEpicBoardsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epic_boards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupEpicBoardsPath(organizationPath, ...routeArgs);
  }

  return _groupEpicBoardsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epic_boards/:id(.:format)`
 * - Path helper: `group_epic_board_path`
 * - URL helper: `group_epic_board_url`
 * - controller#action: `groups/epic_boards#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupEpicBoardPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicBoardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epic_boards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupEpicBoardPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epic_boards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupEpicBoardPath(organizationPath, ...routeArgs);
  }

  return _groupEpicBoardPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/protected_environments(.:format)`
 * - Path helper: `group_protected_environments_path`
 * - URL helper: `group_protected_environments_url`
 * - controller#action: `groups/protected_environments#create`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupProtectedEnvironmentsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupProtectedEnvironmentsPath(organizationPath, ...routeArgs);
  }

  return _groupProtectedEnvironmentsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/protected_environments/:id(.:format)`
 * - Path helper: `group_protected_environment_path`
 * - URL helper: `group_protected_environment_url`
 * - controller#action: `groups/protected_environments#update`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupProtectedEnvironmentPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupProtectedEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupProtectedEnvironmentPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupProtectedEnvironmentPath(organizationPath, ...routeArgs);
  }

  return _groupProtectedEnvironmentPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/dashboard(.:format)`
 * - Path helper: `group_security_dashboard_path`
 * - URL helper: `group_security_dashboard_url`
 * - controller#action: `groups/security/dashboard#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityDashboardPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityDashboardPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityDashboardPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityDashboardPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/inventory(.:format)`
 * - Path helper: `group_security_inventory_path`
 * - URL helper: `group_security_inventory_url`
 * - controller#action: `groups/security/inventory#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityInventoryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityInventoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityInventoryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityInventoryPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityInventoryPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/configuration(.:format)`
 * - Path helper: `group_security_configuration_path`
 * - URL helper: `group_security_configuration_url`
 * - controller#action: `groups/security/configuration#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityConfigurationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityConfigurationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityConfigurationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityConfigurationPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityConfigurationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/vulnerabilities(.:format)`
 * - Path helper: `group_security_vulnerabilities_path`
 * - URL helper: `group_security_vulnerabilities_url`
 * - controller#action: `groups/security/vulnerabilities#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityVulnerabilitiesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityVulnerabilitiesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityVulnerabilitiesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityVulnerabilitiesPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityVulnerabilitiesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/agent_artifacts/:id/download(.:format)`
 * - Path helper: `download_group_security_agent_artifact_path`
 * - URL helper: `download_group_security_agent_artifact_url`
 * - controller#action: `groups/security/agent_artifacts#download`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const downloadGroupSecurityAgentArtifactPath = /*#__PURE__*/ (...args) => {
  const _downloadOrganizationGroupSecurityAgentArtifactPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _downloadGroupSecurityAgentArtifactPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _downloadOrganizationGroupSecurityAgentArtifactPath(organizationPath, ...routeArgs);
  }

  return _downloadGroupSecurityAgentArtifactPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/agent_artifacts/:id/download_session(.:format)`
 * - Path helper: `download_session_group_security_agent_artifact_path`
 * - URL helper: `download_session_group_security_agent_artifact_url`
 * - controller#action: `groups/security/agent_artifacts#download_session`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const downloadSessionGroupSecurityAgentArtifactPath = /*#__PURE__*/ (...args) => {
  const _downloadSessionOrganizationGroupSecurityAgentArtifactPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _downloadSessionGroupSecurityAgentArtifactPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _downloadSessionOrganizationGroupSecurityAgentArtifactPath(organizationPath, ...routeArgs);
  }

  return _downloadSessionGroupSecurityAgentArtifactPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_frameworks/import(.:format)`
 * - Path helper: `import_group_security_compliance_frameworks_path`
 * - URL helper: `import_group_security_compliance_frameworks_url`
 * - controller#action: `groups/security/compliance_dashboard/compliance_frameworks_import#create`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const importGroupSecurityComplianceFrameworksPath = /*#__PURE__*/ (...args) => {
  const _importOrganizationGroupSecurityComplianceFrameworksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _importGroupSecurityComplianceFrameworksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _importOrganizationGroupSecurityComplianceFrameworksPath(organizationPath, ...routeArgs);
  }

  return _importGroupSecurityComplianceFrameworksPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_frameworks(.:format)`
 * - Path helper: `group_security_compliance_frameworks_path`
 * - URL helper: `group_security_compliance_frameworks_url`
 * - controller#action: `groups/security/compliance_frameworks#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceFrameworksPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceFrameworksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceFrameworksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceFrameworksPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceFrameworksPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_frameworks/new(.:format)`
 * - Path helper: `new_group_security_compliance_framework_path`
 * - URL helper: `new_group_security_compliance_framework_url`
 * - controller#action: `groups/security/compliance_frameworks#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupSecurityComplianceFrameworkPath(organizationPath, ...routeArgs);
  }

  return _newGroupSecurityComplianceFrameworkPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_frameworks/:id/edit(.:format)`
 * - Path helper: `edit_group_security_compliance_framework_path`
 * - URL helper: `edit_group_security_compliance_framework_url`
 * - controller#action: `groups/security/compliance_frameworks#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupSecurityComplianceFrameworkPath(organizationPath, ...routeArgs);
  }

  return _editGroupSecurityComplianceFrameworkPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_frameworks/:id(.:format)`
 * - Path helper: `group_security_compliance_framework_path`
 * - URL helper: `group_security_compliance_framework_url`
 * - controller#action: `groups/security/compliance_frameworks#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceFrameworkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceFrameworkPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceFrameworkPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_dashboard/frameworks/:id(.:format)`
 * - Path helper: `group_security_compliance_dashboard_framework_path`
 * - URL helper: `group_security_compliance_dashboard_framework_url`
 * - controller#action: `groups/security/compliance_dashboard/frameworks#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceDashboardFrameworkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceDashboardFrameworkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"frameworks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceDashboardFrameworkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"frameworks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceDashboardFrameworkPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceDashboardFrameworkPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_dashboard/exports/compliance_status_report(.:format)`
 * - Path helper: `group_security_compliance_dashboard_exports_compliance_status_report_path`
 * - URL helper: `group_security_compliance_dashboard_exports_compliance_status_report_url`
 * - controller#action: `groups/security/compliance_dashboard/exports#compliance_status_report`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceDashboardExportsComplianceStatusReportPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceDashboardExportsComplianceStatusReportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"compliance_status_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceDashboardExportsComplianceStatusReportPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"compliance_status_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceDashboardExportsComplianceStatusReportPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceDashboardExportsComplianceStatusReportPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_dashboard/exports/violations_report(.:format)`
 * - Path helper: `group_security_compliance_dashboard_exports_violations_report_path`
 * - URL helper: `group_security_compliance_dashboard_exports_violations_report_url`
 * - controller#action: `groups/security/compliance_dashboard/exports#violations_report`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceDashboardExportsViolationsReportPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceDashboardExportsViolationsReportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"violations_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceDashboardExportsViolationsReportPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"violations_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceDashboardExportsViolationsReportPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceDashboardExportsViolationsReportPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_dashboard(/*vueroute)(.:format)`
 * - Path helper: `group_security_compliance_dashboard_path`
 * - URL helper: `group_security_compliance_dashboard_url`
 * - controller#action: `groups/security/compliance_dashboards#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceDashboardPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceDashboardPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceDashboardPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/discover(.:format)`
 * - Path helper: `group_security_discover_path`
 * - URL helper: `group_security_discover_url`
 * - controller#action: `groups/security/discover#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityDiscoverPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityDiscoverPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityDiscoverPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityDiscoverPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityDiscoverPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/credentials/:credential_id/resources/:resource_id/revoke(.:format)`
 * - Path helper: `group_security_credential_resource_revoke_path`
 * - URL helper: `group_security_credential_resource_revoke_url`
 * - controller#action: `groups/security/credentials#revoke`
 *
 * @param {any} groupId
 * @param {any} credentialId
 * @param {any} resourceId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityCredentialResourceRevokePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityCredentialResourceRevokePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"credential_id":{"r":true},"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"credential_id"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityCredentialResourceRevokePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"credential_id":{"r":true},"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"credential_id"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityCredentialResourceRevokePath(organizationPath, ...routeArgs);
  }

  return _groupSecurityCredentialResourceRevokePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/credentials/:id/revoke(.:format)`
 * - Path helper: `revoke_group_security_credential_path`
 * - URL helper: `revoke_group_security_credential_url`
 * - controller#action: `groups/security/credentials#revoke`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const revokeGroupSecurityCredentialPath = /*#__PURE__*/ (...args) => {
  const _revokeOrganizationGroupSecurityCredentialPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _revokeGroupSecurityCredentialPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _revokeOrganizationGroupSecurityCredentialPath(organizationPath, ...routeArgs);
  }

  return _revokeGroupSecurityCredentialPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/credentials(.:format)`
 * - Path helper: `group_security_credentials_path`
 * - URL helper: `group_security_credentials_url`
 * - controller#action: `groups/security/credentials#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityCredentialsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityCredentialsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityCredentialsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityCredentialsPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityCredentialsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/credentials/:id(.:format)`
 * - Path helper: `group_security_credential_path`
 * - URL helper: `group_security_credential_url`
 * - controller#action: `groups/security/credentials#destroy`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityCredentialPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityCredentialPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityCredentialPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityCredentialPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityCredentialPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/policies/schema(.:format)`
 * - Path helper: `schema_group_security_policies_path`
 * - URL helper: `schema_group_security_policies_url`
 * - controller#action: `groups/security/policies#schema`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const schemaGroupSecurityPoliciesPath = /*#__PURE__*/ (...args) => {
  const _schemaOrganizationGroupSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _schemaGroupSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _schemaOrganizationGroupSecurityPoliciesPath(organizationPath, ...routeArgs);
  }

  return _schemaGroupSecurityPoliciesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/policies(.:format)`
 * - Path helper: `group_security_policies_path`
 * - URL helper: `group_security_policies_url`
 * - controller#action: `groups/security/policies#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityPoliciesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityPoliciesPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityPoliciesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/policies/new(.:format)`
 * - Path helper: `new_group_security_policy_path`
 * - URL helper: `new_group_security_policy_url`
 * - controller#action: `groups/security/policies#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupSecurityPolicyPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupSecurityPolicyPath(organizationPath, ...routeArgs);
  }

  return _newGroupSecurityPolicyPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/policies/:id/edit(.:format)`
 * - Path helper: `edit_group_security_policy_path`
 * - URL helper: `edit_group_security_policy_url`
 * - controller#action: `groups/security/policies#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupSecurityPolicyPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupSecurityPolicyPath(organizationPath, ...routeArgs);
  }

  return _editGroupSecurityPolicyPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/policy_store(.:format)`
 * - Path helper: `group_security_policy_store_index_path`
 * - URL helper: `group_security_policy_store_index_url`
 * - controller#action: `groups/security/policy_store#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityPolicyStoreIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityPolicyStoreIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policy_store"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityPolicyStoreIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policy_store"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityPolicyStoreIndexPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityPolicyStoreIndexPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/policy_store/new(.:format)`
 * - Path helper: `new_group_security_policy_store_path`
 * - URL helper: `new_group_security_policy_store_url`
 * - controller#action: `groups/security/policy_store#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newGroupSecurityPolicyStorePath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSecurityPolicyStorePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policy_store"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSecurityPolicyStorePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policy_store"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationGroupSecurityPolicyStorePath(organizationPath, ...routeArgs);
  }

  return _newGroupSecurityPolicyStorePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/policy_store/:id/edit(.:format)`
 * - Path helper: `edit_group_security_policy_store_path`
 * - URL helper: `edit_group_security_policy_store_url`
 * - controller#action: `groups/security/policy_store#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editGroupSecurityPolicyStorePath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSecurityPolicyStorePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policy_store"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSecurityPolicyStorePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policy_store"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationGroupSecurityPolicyStorePath(organizationPath, ...routeArgs);
  }

  return _editGroupSecurityPolicyStorePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/policy_store/:id(.:format)`
 * - Path helper: `group_security_policy_store_path`
 * - URL helper: `group_security_policy_store_url`
 * - controller#action: `groups/security/policy_store#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityPolicyStorePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityPolicyStorePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policy_store"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityPolicyStorePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policy_store"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityPolicyStorePath(organizationPath, ...routeArgs);
  }

  return _groupSecurityPolicyStorePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/dependency_firewall(.:format)`
 * - Path helper: `group_security_dependency_firewall_path`
 * - URL helper: `group_security_dependency_firewall_url`
 * - controller#action: `groups/security/dependency_firewall#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityDependencyFirewallPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityDependencyFirewallPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dependency_firewall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityDependencyFirewallPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dependency_firewall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityDependencyFirewallPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityDependencyFirewallPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/merge_commit_reports(.:format)`
 * - Path helper: `group_security_merge_commit_reports_path`
 * - URL helper: `group_security_merge_commit_reports_url`
 * - controller#action: `groups/security/merge_commit_reports#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityMergeCommitReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityMergeCommitReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"merge_commit_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityMergeCommitReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"merge_commit_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityMergeCommitReportsPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityMergeCommitReportsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_project_framework_reports(.:format)`
 * - Path helper: `group_security_compliance_project_framework_reports_path`
 * - URL helper: `group_security_compliance_project_framework_reports_url`
 * - controller#action: `groups/security/compliance_project_framework_reports#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceProjectFrameworkReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceProjectFrameworkReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_project_framework_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceProjectFrameworkReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_project_framework_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceProjectFrameworkReportsPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceProjectFrameworkReportsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_violation_reports(.:format)`
 * - Path helper: `group_security_compliance_violation_reports_path`
 * - URL helper: `group_security_compliance_violation_reports_url`
 * - controller#action: `groups/security/compliance_violation_reports#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceViolationReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceViolationReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_violation_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceViolationReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_violation_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceViolationReportsPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceViolationReportsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_standards_adherence_reports(.:format)`
 * - Path helper: `group_security_compliance_standards_adherence_reports_path`
 * - URL helper: `group_security_compliance_standards_adherence_reports_url`
 * - controller#action: `groups/security/compliance_standards_adherence_reports#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceStandardsAdherenceReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceStandardsAdherenceReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_standards_adherence_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceStandardsAdherenceReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_standards_adherence_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceStandardsAdherenceReportsPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceStandardsAdherenceReportsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/security/compliance_framework_reports(.:format)`
 * - Path helper: `group_security_compliance_framework_reports_path`
 * - URL helper: `group_security_compliance_framework_reports_url`
 * - controller#action: `groups/security/compliance_framework_reports#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecurityComplianceFrameworkReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceFrameworkReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_framework_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceFrameworkReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_framework_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecurityComplianceFrameworkReportsPath(organizationPath, ...routeArgs);
  }

  return _groupSecurityComplianceFrameworkReportsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/dependencies/licenses(.:format)`
 * - Path helper: `licenses_group_dependencies_path`
 * - URL helper: `licenses_group_dependencies_url`
 * - controller#action: `groups/dependencies#licenses`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const licensesGroupDependenciesPath = /*#__PURE__*/ (...args) => {
  const _licensesOrganizationGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _licensesGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _licensesOrganizationGroupDependenciesPath(organizationPath, ...routeArgs);
  }

  return _licensesGroupDependenciesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/dependencies/locations(.:format)`
 * - Path helper: `locations_group_dependencies_path`
 * - URL helper: `locations_group_dependencies_url`
 * - controller#action: `groups/dependencies#locations`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const locationsGroupDependenciesPath = /*#__PURE__*/ (...args) => {
  const _locationsOrganizationGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _locationsGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _locationsOrganizationGroupDependenciesPath(organizationPath, ...routeArgs);
  }

  return _locationsGroupDependenciesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/dependencies(.:format)`
 * - Path helper: `group_dependencies_path`
 * - URL helper: `group_dependencies_url`
 * - controller#action: `groups/dependencies#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupDependenciesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupDependenciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupDependenciesPath(organizationPath, ...routeArgs);
  }

  return _groupDependenciesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/push_rules(.:format)`
 * - Path helper: `group_push_rules_path`
 * - URL helper: `group_push_rules_url`
 * - controller#action: `groups/push_rules#update`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupPushRulesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupPushRulesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"push_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupPushRulesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"push_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupPushRulesPath(organizationPath, ...routeArgs);
  }

  return _groupPushRulesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/protected_branches(.:format)`
 * - Path helper: `group_protected_branches_path`
 * - URL helper: `group_protected_branches_url`
 * - controller#action: `groups/protected_branches#create`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupProtectedBranchesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupProtectedBranchesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupProtectedBranchesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupProtectedBranchesPath(organizationPath, ...routeArgs);
  }

  return _groupProtectedBranchesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/protected_branches/:id(.:format)`
 * - Path helper: `group_protected_branch_path`
 * - URL helper: `group_protected_branch_url`
 * - controller#action: `groups/protected_branches#update`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupProtectedBranchPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupProtectedBranchPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_branches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupProtectedBranchPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_branches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupProtectedBranchPath(organizationPath, ...routeArgs);
  }

  return _groupProtectedBranchPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/saml/callback(.:format)`
 * - Path helper: `callback_group_saml_providers_path`
 * - URL helper: `callback_group_saml_providers_url`
 * - controller#action: `groups/omniauth_callbacks#group_saml`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callbackGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/saml/sso(.:format)`
 * - Path helper: `sso_group_saml_providers_path`
 * - URL helper: `sso_group_saml_providers_url`
 * - controller#action: `groups/sso#saml`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ssoGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/saml/unlink(.:format)`
 * - Path helper: `unlink_group_saml_providers_path`
 * - URL helper: `unlink_group_saml_providers_url`
 * - controller#action: `groups/sso#unlink`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const unlinkGroupSamlProvidersPath = /*#__PURE__*/ (...args) => {
  const _unlinkOrganizationGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _unlinkGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _unlinkOrganizationGroupSamlProvidersPath(organizationPath, ...routeArgs);
  }

  return _unlinkGroupSamlProvidersPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/saml/update_microsoft_application(.:format)`
 * - Path helper: `update_microsoft_application_group_saml_providers_path`
 * - URL helper: `update_microsoft_application_group_saml_providers_url`
 * - controller#action: `groups/saml_providers#update_microsoft_application`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const updateMicrosoftApplicationGroupSamlProvidersPath = /*#__PURE__*/ (...args) => {
  const _updateMicrosoftApplicationOrganizationGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"update_microsoft_application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _updateMicrosoftApplicationGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"update_microsoft_application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _updateMicrosoftApplicationOrganizationGroupSamlProvidersPath(organizationPath, ...routeArgs);
  }

  return _updateMicrosoftApplicationGroupSamlProvidersPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/saml(.:format)`
 * - Path helper: `group_saml_providers_path`
 * - URL helper: `group_saml_providers_url`
 * - controller#action: `groups/saml_providers#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSamlProvidersPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSamlProvidersPath(organizationPath, ...routeArgs);
  }

  return _groupSamlProvidersPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/scim_oauth(.:format)`
 * - Path helper: `group_scim_oauth_path`
 * - URL helper: `group_scim_oauth_url`
 * - controller#action: `groups/scim_oauth#create`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupScimOauthPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupScimOauthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"scim_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupScimOauthPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"scim_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupScimOauthPath(organizationPath, ...routeArgs);
  }

  return _groupScimOauthPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/roadmap(.:format)`
 * - Path helper: `group_roadmap_path`
 * - URL helper: `group_roadmap_url`
 * - controller#action: `groups/roadmap#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupRoadmapPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupRoadmapPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"roadmap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupRoadmapPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"roadmap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupRoadmapPath(organizationPath, ...routeArgs);
  }

  return _groupRoadmapPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/work_items/:iid/descriptions/:version_id/diff(.:format)`
 * - Path helper: `description_diff_group_work_item_path`
 * - URL helper: `description_diff_group_work_item_url`
 * - controller#action: `groups/work_items#description_diff`
 *
 * @param {any} groupId
 * @param {any} iid
 * @param {any} versionId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const descriptionDiffGroupWorkItemPath = /*#__PURE__*/ (...args) => {
  const _descriptionDiffOrganizationGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"iid":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[2,[7,"/"],[2,[6,"diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _descriptionDiffGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"iid":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[2,[7,"/"],[2,[6,"diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _descriptionDiffOrganizationGroupWorkItemPath(organizationPath, ...routeArgs);
  }

  return _descriptionDiffGroupWorkItemPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/work_items/:iid/descriptions/:version_id(.:format)`
 * - Path helper: `delete_description_version_group_work_item_path`
 * - URL helper: `delete_description_version_group_work_item_url`
 * - controller#action: `groups/work_items#delete_description_version`
 *
 * @param {any} groupId
 * @param {any} iid
 * @param {any} versionId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const deleteDescriptionVersionGroupWorkItemPath = /*#__PURE__*/ (...args) => {
  const _deleteDescriptionVersionOrganizationGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"iid":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _deleteDescriptionVersionGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"iid":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _deleteDescriptionVersionOrganizationGroupWorkItemPath(organizationPath, ...routeArgs);
  }

  return _deleteDescriptionVersionGroupWorkItemPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/discover(.:format)`
 * - Path helper: `group_discover_path`
 * - URL helper: `group_discover_url`
 * - controller#action: `groups/discovers#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupDiscoverPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupDiscoverPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupDiscoverPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupDiscoverPath(organizationPath, ...routeArgs);
  }

  return _groupDiscoverPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/runners/dashboard(.:format)`
 * - Path helper: `dashboard_group_runners_path`
 * - URL helper: `dashboard_group_runners_url`
 * - controller#action: `groups/runners#dashboard`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const dashboardGroupRunnersPath = /*#__PURE__*/ (...args) => {
  const _dashboardOrganizationGroupRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _dashboardGroupRunnersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _dashboardOrganizationGroupRunnersPath(organizationPath, ...routeArgs);
  }

  return _dashboardGroupRunnersPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/automate/governance`
 * - Path helper: `group_automate_governance_path`
 * - URL helper: `group_automate_governance_url`
 * - controller#action: `groups/automate/governance#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAutomateGovernancePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateGovernancePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"governance"]]]]]]]]]]]]]]);
  const _groupAutomateGovernancePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"governance"]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAutomateGovernancePath(organizationPath, ...routeArgs);
  }

  return _groupAutomateGovernancePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/automate(/*vueroute)`
 * - Path helper: `group_automate_path`
 * - URL helper: `group_automate_url`
 * - controller#action: `groups/duo_agents_platform#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAutomatePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]);
  const _groupAutomatePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAutomatePath(organizationPath, ...routeArgs);
  }

  return _groupAutomatePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/automate/agent-sessions/:id`
 * - Path helper: `group_automate_agent_session_path`
 * - URL helper: `group_automate_agent_session_url`
 * - controller#action: `groups/duo_agents_platform#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAutomateAgentSessionPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateAgentSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agent-sessions"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _groupAutomateAgentSessionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agent-sessions"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAutomateAgentSessionPath(organizationPath, ...routeArgs);
  }

  return _groupAutomateAgentSessionPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/automate/agents`
 * - Path helper: `group_automate_agents_path`
 * - URL helper: `group_automate_agents_url`
 * - controller#action: `groups/duo_agents_platform#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAutomateAgentsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateAgentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agents"]]]]]]]]]]]]]]);
  const _groupAutomateAgentsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agents"]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAutomateAgentsPath(organizationPath, ...routeArgs);
  }

  return _groupAutomateAgentsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/automate/agents/:id`
 * - Path helper: `group_automate_agent_path`
 * - URL helper: `group_automate_agent_url`
 * - controller#action: `groups/duo_agents_platform#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAutomateAgentPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateAgentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _groupAutomateAgentPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAutomateAgentPath(organizationPath, ...routeArgs);
  }

  return _groupAutomateAgentPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/automate/flows`
 * - Path helper: `group_automate_flows_path`
 * - URL helper: `group_automate_flows_url`
 * - controller#action: `groups/duo_agents_platform#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAutomateFlowsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateFlowsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"flows"]]]]]]]]]]]]]]);
  const _groupAutomateFlowsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"flows"]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAutomateFlowsPath(organizationPath, ...routeArgs);
  }

  return _groupAutomateFlowsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/automate/flows/:id`
 * - Path helper: `group_automate_flow_path`
 * - URL helper: `group_automate_flow_url`
 * - controller#action: `groups/duo_agents_platform#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAutomateFlowPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateFlowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _groupAutomateFlowPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAutomateFlowPath(organizationPath, ...routeArgs);
  }

  return _groupAutomateFlowPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/automate/mcp-servers`
 * - Path helper: `group_automate_mcp_servers_path`
 * - URL helper: `group_automate_mcp_servers_url`
 * - controller#action: `groups/duo_agents_platform#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupAutomateMcpServersPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateMcpServersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"mcp-servers"]]]]]]]]]]]]]]);
  const _groupAutomateMcpServersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"mcp-servers"]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupAutomateMcpServersPath(organizationPath, ...routeArgs);
  }

  return _groupAutomateMcpServersPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/secrets(/*vueroute)(.:format)`
 * - Path helper: `group_secrets_path`
 * - URL helper: `group_secrets_url`
 * - controller#action: `groups/secrets#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupSecretsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecretsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"secrets"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _groupSecretsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"secrets"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupSecretsPath(organizationPath, ...routeArgs);
  }

  return _groupSecretsPath(...routeArgs);
};

